<template>
    <portal to="modal">
        <transition @before-enter="beforeOpen" @after-enter="afterOpen" @before-leave="beforeClose" @after-leave="afterClose" enter-active-class="transition opacity-100 ease-in duration-200" leave-active-class="transition opacity-0 ease-out duration-200">
            <div v-if="show" class="fixed z-70 inset-0 px-4 py-6 overflow-y-auto sm:px-0">
                <div class="fixed inset-0 transform transition-all backdrop-blur-lg backdrop-contrast-100 backdrop-filter" @click="close">
                    <div class="absolute z-70 inset-0 bg-white bg-opacity-10"></div>
                </div>

                <div :class="[maxWidthClass, maxHeightClass]" class="mb-6 bg-white dark:bg-slate-800 rounded-lg shadow-xl overflow-hidden transform transition-all sm:mx-auto sm:w-full">
                    <slot></slot>
                </div>
            </div>
        </transition>
    </portal>
</template>

<script>
export default {
    props: {
        show: {
            default: false,
        },
        maxWidth: {
            default: "2xl",
        },
        maxHeight: {
            default: null,
        },
        closeable: {
            default: true,
        },
        preserveBackdrop: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        beforeOpen() {
            this.$emit("before-open")
            document.body.style.overflow = "hidden"
            document.body.style.height = "100vh"
            document.body.style.paddingRight = "15px"
        },

        afterOpen() {
            this.$emit("after-open")
            // document.body.style.overflow = "hidden"
            // document.body.style.height = "100vh"
            // document.body.style.paddingRight = "15px"
        },

        close() {
            if (this.closeable) {
                this.$emit("close")
            }
        },

        beforeClose() {
            this.$emit("before-close")
            if (!this.preserveBackdrop) {
                document.body.style.overflow = null
                document.body.style.height = null
                document.body.style.paddingRight = null
            }
        },

        afterClose() {
            this.$emit("after-close")
        },
    },

    created() {
        const closeOnEscape = (e) => {
            if (e.key === "Escape" && this.show) {
                this.close()
            }
        }

        document.addEventListener("keydown", closeOnEscape)

        this.$once("hook:destroyed", () => {
            document.removeEventListener("keydown", closeOnEscape)
        })
    },

    computed: {
        maxWidthClass() {
            return {
                sm: "sm:max-w-sm",
                md: "sm:max-w-md",
                lg: "sm:max-w-lg",
                xl: "sm:max-w-xl",
                "2xl": "sm:max-w-2xl",
                "3xl": "sm:max-w-3xl",
                "4xl": "sm:max-w-4xl",
                "5xl": "sm:max-w-5xl",
            }[this.maxWidth]
        },

        maxHeightClass() {
            return {
                full: "sm:max-h-full",
                screen: "sm:max-h-screen",
            }[this.maxHeight]
        },
    },
}
</script>
